import { BetslipPick } from '../../core/picks/betslip-pick';
import { PickId } from '../../core/picks/pick-id';
import { IBetslipPickStorage } from '../../core/picks/pick-models';

export interface IPickUiState {
    highlightPick: boolean;
    expandLegs: boolean;
}

export interface IRemoveablePick {
    pickId: PickId | undefined;
    hasError: boolean;
    previousHadError: boolean;
}

export interface IRemoveablePickSavedState {
    pickId: string | undefined;
    hasError: boolean;
    previousHadError: boolean;
}

export interface IBetslipPickState {
    pickList: BetslipPick[];
    ui: Record<string, IPickUiState>;
    lastPickError: IRemoveablePick;
}

export interface IBetslipPickSavedState extends Omit<IBetslipPickState, 'pickList' | 'lastPickError'> {
    pickList: IBetslipPickStorage[];
    lastPickError: IRemoveablePickSavedState;
}

export const defaultLastPickErrorState: IRemoveablePick = Object.freeze({
    pickId: undefined,
    hasError: false,
    previousHadError: false,
});

export const defaultPickState: IBetslipPickState = {
    pickList: [],
    ui: {},
    lastPickError: defaultLastPickErrorState,
};

export const defaultPickUiState: IPickUiState = Object.freeze({
    highlightPick: false,
    expandLegs: false,
});
